import React from 'react'
import StudentList from './StudentList'
import {withRouter} from 'react-router-dom' 
import {connect} from 'react-redux'
import axios from 'axios'
import getHouseDetails from '../actions/getHouseDetails'

class HouseDetails extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            searchQuery : '',
        }
    }

    componentDidMount(){
            this.props.getHouseDetail(this.props.match.params.id)
        }
    
    componentDidUpdate(prevProps){
        if(prevProps.match.params.id !== this.props.match.params.id){
            this.props.getHouseDetail(this.props.match.params.id)
        }
    }

    handleFormChange = (e) => {
        this.setState({searchQuery : e.target.value})
    }

    listStudents = () => {
        const regex = new RegExp(this.state.searchQuery, 'i')
        let arr = this.props.house.members.filter( member => regex.test(member.name))
        return arr
    }
    
    render(){
        console.log('ini props : ')
        console.log(this.props)
        const showTable = this.props.house.members.length > 0
        return(
        <div style={{heigth : 100 + 'vh'}} className=" mt-3 p-5 border shadow h-100 bg-white rounded">
            <div className="container">
                <div className="row">
                    <div className="col-12 mx-auto">
                        <div className="row ml-1">
                            <div>
                                <h1>{this.props.house.name}</h1>
                            </div>
                            <div className="ml-auto mr-3">
                                <input type="text" className="form-control" onChange={this.handleFormChange} placeholder="Accio student..!"/>
                            </div>
                        </div>
                        <h3>{this.props.house.headOfHouse}</h3>
                        {showTable && <h3 className="mt-3">Students : </h3>}
                        {
                            showTable && <StudentList members={this.listStudents()} getPersonDetails={this.props.getPersonDetails}/>
                        }
                    </div>
                </div>
            </div>
        </div>
        )
    }

}

const mapStateToProps = state => {
    return{
        house: state.house
    }
}

const mapDispatchToProps = dispatch => {
    return{
        getHouseDetail : (id)=> dispatch(getHouseDetails(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HouseDetails))

// export default (withRouter(HouseDetails))